import { Button, Modal, Paper, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { CandidateCreate } from "../interfaces/Candidate";
import { ResponseContainer } from "../interfaces/RequestBase";
import { CreateCandidate } from "../requester/functions";
import VO, { VK } from "../utilities/validate";
import DataSelect from "./DataInputs/DataSelect";
import DataDate from "./DataInputs/DataDate";
import DataTextField from "./DataInputs/DataTextField";

interface IProps {
	open: boolean;
	onClose(): void;
	onCreate?(): void;
}

const candidateTempalte: CandidateCreate = {
	first_name: "",
	last_name: "",
	birthday: undefined,
	gender: 1,
	email: "",
	phone: "",
};

const CreateCandidateModal = (props: IProps) => {
	const { enqueueSnackbar } = useSnackbar();

	const [candidate, setCandidate] = useState<CandidateCreate>({
		...candidateTempalte,
	});

	return (
		<Modal
			open={props.open}
			onClose={props.onClose}
			className="flex items-center justify-center "
		>
			<Paper className="focus-visible:outline-none p-5 min-w-[400px] min-h-[200px] flex flex-col gap-5 items-center justify-between">
				<Typography>Создание кандидата</Typography>
				<DataTextField
					className="w-full"
					value={candidate}
					setValue={setCandidate}
					keyValue={"first_name"}
					inputProps={{
						label: "Имя",
						required: true,
						error: !VK(candidate.first_name),
					}}
				/>
				<DataTextField
					className="w-full"
					value={candidate}
					setValue={setCandidate}
					keyValue={"last_name"}
					inputProps={{
						label: "Фамилия",
						required: true,
						error: !VK(candidate.last_name),
					}}
				/>
				<DataTextField
					className="w-full"
					value={candidate}
					setValue={setCandidate}
					keyValue={"patronymic"}
					inputProps={{
						label: "Отчество",
					}}
				/>
				<DataTextField
					className="w-full"
					value={candidate}
					setValue={setCandidate}
					keyValue={"email"}
					inputProps={{
						label: "Почта",
						required: true,
						error: !VK(candidate.email),
					}}
				/>
				<DataSelect
					list={[
						{ id: 1, name: "Муж." },
						{ id: 2, name: "Жен." },
					]}
					value={candidate}
					setValue={setCandidate}
					keyValue={"gender"}
					label={"Пол"}
					className="w-full"
				/>

				<DataDate
					value={candidate}
					setValue={setCandidate}
					keyValue={"birthday"}
					label="День рождения"
					className="w-[200]"
					inputProps={{
						required: true,
						error: !VK(candidate.birthday),
					}}
				/>

				<DataTextField
					className="w-full"
					value={candidate}
					setValue={setCandidate}
					keyValue={"phone"}
					inputProps={{
						label: "Телефон",
						required: true,
						error: !VK(candidate.phone),
					}}
				/>
				<Button
					variant="contained"
					onClick={() => {
						CreateCandidate(candidate, (resp: ResponseContainer<null>) => {
							if (resp.status === "ok") {
								enqueueSnackbar("Пользователь создан", {
									variant: "success",
								});
								props.onCreate?.();
								props.onClose();
							} else {
								enqueueSnackbar(`Ошибка ${resp.code}, ${resp.message}`, {
									variant: "error",
								});
							}
						});
					}}
					disabled={!VO(candidate, candidateTempalte)}
				>
					Сохранить
				</Button>
			</Paper>
		</Modal>
	);
};

export default CreateCandidateModal;
